import React from 'react'
import "./index.css"

const TicketPageLoader = () => {
    return (
        <div className="loader"></div>
    )
}

export default TicketPageLoader